import {IApiService} from '../../../../types/src';

export class TagsService {
  client: IApiService;
  serviceName = 'tags';
  constructor({client}: {client: IApiService}) {
    this.client = client;
  }

  getTags() {
    return this.client.get(`api/v2/${this.serviceName}/all`, '');
  }

  addTags(tags: string[], receivers: number[]) {
    return this.client.post(`api/v2/${this.serviceName}/tag`, {
      receivers,
      tags,
    });
  }

  removeTags(tags: string[], receivers: number[]) {
    return this.client.post(`api/v2/${this.serviceName}/untag`, {
      receivers,
      tags,
    });
  }

  renameTag(old_name: string, new_name: string) {
    return this.client.post(`api/v2/${this.serviceName}/rename`, {
      old_name,
      new_name,
    });
  }

  deleteTag(tag_name: string, force_delete: boolean, replace_tag_name?: string) {
    return this.client.post(`api/v2/${this.serviceName}/delete`, {
      tag_name,
      force_delete,
      ...(replace_tag_name ? {replace_tag_name} : {}),
    });
  }
}
